import { z } from "zod";

export enum SnippetImportance {
  Critical = 1,
  Important = 2,
  Supporting = 3,
  Supplementary = 4,
}

export const snippetImportanceSchema = z.nativeEnum(SnippetImportance);
